export type GenerateBillingInvoicePayload = {
  folioId: string;
  guestId: string;
  reservationId?: string;
  stayId?: string;
  totalAmount: number;
  currency: "EUR" | "USD" | "PLN";
};

export type GenerateBillingInvoiceResult = {
  provider: string;
  documentId: string;
};

export interface BillingInvoiceProvider {
  generateInvoice(payload: GenerateBillingInvoicePayload): Promise<GenerateBillingInvoiceResult>;
}

export class InMemoryBillingInvoiceProvider implements BillingInvoiceProvider {
  readonly provider = "in-memory-billing-invoice";
  readonly generatedPayloads: GenerateBillingInvoicePayload[] = [];

  async generateInvoice(payload: GenerateBillingInvoicePayload): Promise<GenerateBillingInvoiceResult> {
    this.generatedPayloads.push(payload);
    return {
      provider: this.provider,
      documentId: `bill-${this.generatedPayloads.length.toString().padStart(4, "0")}`,
    };
  }
}
